<mat-toolbar class="stick-top">
  <mat-icon>work</mat-icon>
  Update task
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" type="button" (click)="set()" [disabled]="!taskCarrierId || !taskId || !status">
    Update
  </button>
</div>

<div class="padded vbox vbox-space">
  <div>
    <form #form="ngForm" role="form">
      <table class="basicTable">
        <thead>
        <tr>
          <th colspan="100">Update task</th>
        </tr>
        <tr>
          <th style="width: 200px;">Carrier</th>
          <th>Task ID</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <micro-taskCarrier-select [(taskCarrierId)]="taskCarrierId" [required]="true"></micro-taskCarrier-select>
          </td>
          <td>
            <input [(ngModel)]="taskId" required placeholder="Task ID" id="taskId" name="taskId">
          </td>
          <td>
            <select [(ngModel)]="status" required id="taskStatus" name="taskStatus">
              <option value="">--SELECT--</option>
              <option value="In Progress">In Progress</option>
              <option value="Review">Review</option>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>


